module.exports = __webpack_public_path__ + "img/rejected-small.c70cbd95.svg";